import { categoriesService } from "../../api_client";
import { useApi } from "../../../swr/useApi";
import type { EffectiveFieldConfig } from "../../categories/data/field-config";
import { defaultEffectiveConfig } from "../../categories/data/field-config";

/**
 * Effective per-category field policy for the seller product form.
 *
 * When no category is selected we don't hit the API and return the permissive
 * default (everything visible, nothing required) so the form behaves exactly
 * as it did before a category is picked.
 */
export function useCategoryFieldConfig(categoryId: number | null | undefined) {
  const enabled = categoryId != null && !Number.isNaN(categoryId);

  const { data, isLoading, error } = useApi(
    enabled ? `category-field-config-${categoryId}` : null,
    () => categoriesService.getCategoryFieldConfig(categoryId as number),
  );

  return {
    // `config` is typed as Record<string, FieldPolicyDto> by the generated
    // client; our FieldKey-keyed view is the same shape.
    config: (data?.config as EffectiveFieldConfig | undefined) ?? defaultEffectiveConfig(),
    // While a category is selected but its policy is still loading, treat it as
    // loading so call sites can avoid flashing the wrong field set.
    isLoading: enabled ? isLoading : false,
    error,
  };
}
